const ITEMS = [
  "Live ER & clinic wait times",
  "Location stays on your device",
  "Community wait-time reports",
  "Nearest care, shortest wait",
  "Currently in internal testing",
  "Built for Canadian patients",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-transparent py-6 sm:py-7" aria-hidden="true">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {ITEMS.map((t) => (
            <span key={t + k} className="flex items-center font-display text-2xl sm:text-3xl font-semibold tracking-tight text-white/20 whitespace-nowrap">
              <span className="px-8">{t}</span>
              <span className="h-2 w-2 rounded-full bg-[var(--clinical)] opacity-70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
